import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'jhi-modal-confirm',
    template: `
		<jhi-modal [title]="title">
			<div class="modal-body word-wrap" >
                <div class="p-3" [innerHTML]="sanitizer.sanitize(SecurityContext.HTML, message)">
                </div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dismiss()" data-test="modalCancelButton">
					<span class="fa fa-ban" *ngIf="showButtonIcons"></span>&nbsp;<span>{{cancelLabel}}</span>
				</button>
				<button (click)="confirm()" class="btn btn-primary" data-test="modalConfirmButton">
					<span class="fa fa-save" *ngIf="showButtonIcons"></span>&nbsp;<span>{{confirmLabel}}</span>
				</button>
			</div>
		</jhi-modal>
    `
})
export class ModalConfirmComponent implements OnInit {
    @Input() message: string;
    @Input() title: string = this.translateService.instant('confirmation');
    @Input() cancelLabel = this.translateService.instant('cancel');
    @Input() confirmLabel = this.translateService.instant('confirm');
    @Input() showButtonIcons: boolean = true;

    constructor(private modal: NgbActiveModal,
                private translateService: TranslateService,
                public sanitizer: DomSanitizer) {
    }

    ngOnInit(): void {
        if (!this.title) {
            this.title = this.translateService.instant('confirmation');
        }
        if (!this.cancelLabel) {
            this.cancelLabel = this.translateService.instant('cancel');
        }
        if (!this.confirmLabel) {
            this.confirmLabel = this.translateService.instant('confirmation');
        }
    }

    confirm() {
        this.modal.close();
    }

    dismiss() {
        this.modal.dismiss();
    }

    protected readonly SecurityContext = SecurityContext;
}
